import React from 'react';
import { Button } from '@mui/material';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

const ExportCSV = ({ csvData = [], fileName, columns = [], typeReport }) => {

    const fileType =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';

    const exportToExcel = () => {

        // 1️⃣ columnas visibles
        const visibleColumns = columns.filter(
            col => col.field && col.hide !== true
        );

        // 2️⃣ mapear datos según columnas visibles
        const newData = csvData.map(row => {
            const obj = {};

            visibleColumns.forEach(col => {
                let value = row[col.field];

                // Limpieza especial solo para reporte completo
                if (typeReport === 1 && typeof value === 'string') {
                    const ul = /((<ul>|<ol>)|(<\/li>|<br \/>)|(<\/ul>|<\/ol>))/g;
                    const li = /(<li>)/g;
                    value = value.replace(ul, '').replace(li, '  -- ');
                }

                obj[col.headerName] = value ?? '';
            });

            return obj;
        });

        // 3️⃣ generar Excel
        const ws = XLSX.utils.json_to_sheet(newData);
        const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: fileType });

        FileSaver.saveAs(data, `${fileName}${fileExtension}`);
    };

    return (
        <Button
            size="small"
            variant="contained"
            startIcon={<FileDownloadIcon />}
            onClick={exportToExcel}
            disabled={!csvData.length}
        >
            Exportar
        </Button>
    );
};

export default ExportCSV;
